import * as React from 'react';

declare global {
  interface Window {
    __INIT_DATA__: any;
  }
}

interface Config {
  displayName?: string;
}

export const connectSsr = (config: Config = {}) => (WrappedComponent: any) => {
  class C extends React.Component<
    { dispatch: any; location: any },
    { d: any; loading: boolean }
  > {
    public static async getInitialProps(props) {
      if (
        WrappedComponent &&
        typeof WrappedComponent['getInitialProps'] === 'function'
      ) {
        try{
            const c = await WrappedComponent.getInitialProps(props);
            return { ...c, loading: false };
        } catch(error) {

        }
      }
      return {};
    }

    public static getID() {
      return config.displayName;
    }

    public static getHostName() {
      if (typeof window !== 'undefined') {
        return location.hostname;
      }
      return '';
    }

    public getInitData() {
      if (
        config.displayName &&
        typeof window.__INIT_DATA__ !== 'undefined' &&
        window.__INIT_DATA__[config.displayName]
      ) {
        return window.__INIT_DATA__[config.displayName!];
      }
      return null;
    }

    constructor(props) {
      super(props);
      this.state = {
        d: {},
        loading: true
      };
      if (config.displayName) {
        if (window['initialDataAlreadySet'] === undefined) {
          window['initialDataAlreadySet'] = {};
        }
        if (window['initialDataAlreadySet'][config.displayName] === undefined) {
          window['initialDataAlreadySet'][config.displayName!] = false;
        }
      }
    }

    public async componentWillReceiveProps(nextProps) {
      if(!nextProps.location){
        return false;
      }
      if(nextProps.location && nextProps.location.state){
        const state = nextProps.location && nextProps.location.state;
        if(state && !state.reload){
          return false;
        }
      }



      if (
        nextProps.location.pathname !== this.props.location.pathname ||
        nextProps.location.query !== this.props.location.query
      ) {
        this.setState({ loading: true }, async () => {
          const d = await C.getInitialProps({
            ...nextProps,
            hostname: C.getHostName()
          });
          return this.setState({ d, loading: false });
        });
      }
      return false;
    }

    public async componentDidMount() {
      const data = this.getInitData();
      if (
        data === null ||
        (config.displayName &&
          window['initialDataAlreadySet'][config.displayName!] === true)
      ) {
        this.setState({ loading: true });
        const d = await C.getInitialProps({
          ...this.props,
          hostname: C.getHostName()
        });
        return this.setState({ d, loading: false });
      } else {
        if (config.displayName) {
          window['initialDataAlreadySet'][config.displayName!] = true;
        }
      }
      return this.setState({
        d: data,
        loading: false
      });
    }

    public render() {
      let data = {};
      if (
        !config.displayName ||
        window['initialDataAlreadySet'][config.displayName!] === false
      ) {
        data = this.getInitData();
      }
      return <WrappedComponent {...data} {...this.state.d} {...this.props} />;
    }
  }
  return C as any;
};
